import React from 'react'
import SubscriptionBilling from '../../../features/employerDashboard/components/Subscription&Billing'

function SubscriptionBillingPage() {
  return (
    <div>
      <SubscriptionBilling/>
    </div>
  )
}

export default SubscriptionBillingPage
